import React from "react";
import { selectChosenFlightsResults } from "../searchFlightsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import AirlinesDropdown from "../filters/AirlinesDropdown";
import TimeDropdown from "../filters/TimeDropdown";
import StopsDropdown from "../filters/StopsDropdown";
import ViaDropdown from "../filters/ViaDropdown";
import SortDropdown from "../filters/SortDropdown";
import { useAppSelector } from "../../../app/hooks";

function SearchFlightsResultsSort({ processedRows }) {
  const results = useAppSelector(selectChosenFlightsResults);
  const type = useAppSelector((state) => state.searchFlights.results.type);
  const flags = useAppSelector(
    (state) => state.config.components.FilterAndSortMenus
  );
  const mergeFlightResults = useAppSelector(
      (state) => state.config.components.Results.mergeFlightResults
  );
  const { t } = useTranslation();
  const diff = results.flights.length - results.filtered.length;
  const filtered = diff !== 0;
  const allFiltered = results.filtered.length === 0;

  return (
    <>
      <div
        id="sort-results-actions"
        className="columns is-vcentered mb-1 is-mobile"
      >
        <div className="column">
          {results.flights.length > 1 && (
            <>
              {flags.airline && <AirlinesDropdown />}
              {flags.timespan && <TimeDropdown />}
              {flags.stops && type.startsWith("direct") && <StopsDropdown />}
              {flags.via && type.startsWith("connection") && <ViaDropdown />}
              {flags.timesort && <SortDropdown />}
            </>
          )}
        </div>
        <div className="column is-narrow">
          <div className="tags">
            <span className="tag">
              {mergeFlightResults
                  ? `${processedRows.length}/${processedRows.length}`
                  : `${results.filtered.length}/${results.flights.length}`}
            </span>
          </div>
        </div>
      </div>
      {flags.filterWarning && filtered && !allFiltered && (
        <div className="notification is-info m-1">
          <FontAwesomeIcon icon={faInfoCircle} />
          &nbsp;
          {t("WARN_FILTERING")}
        </div>
      )}
      {flags.filterWarning && allFiltered && (
        <div className="notification is-warning m-1">
          <FontAwesomeIcon icon={faExclamationTriangle} />
          &nbsp;
          {t("WARN_FILTERING_ALL")}
        </div>
      )}
    </>
  );
}

export default SearchFlightsResultsSort;
